/**
 * Mirrors backend collapseRepeatedSegments: drops a segment identical to the one
 * before it, e.g. `root-1/folderA/folderA/x.shp` -> `root-1/folderA/x.shp`.
 */
export const collapseRepeatedSegments = (key: string): string =>
  key
    .split('/')
    .filter((seg, i, segs) => i === 0 || seg !== segs[i - 1])
    .join('/');
